(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  let pending = false;
  let resync = null;

  function lineIdentity(variantId, sellingPlanId, properties) {
    if (!variantId) return null;
    const entries = Array.isArray(properties) ? [...properties] : Object.entries(properties || {});
    return JSON.stringify([String(variantId), String(sellingPlanId || ''), entries.sort(([a], [b]) => a.localeCompare(b))]);
  }

  function renderedLineIdentity(line) {
    try {
      return lineIdentity(line.dataset.cartVariantId, line.dataset.cartSellingPlanId, JSON.parse(line.dataset.cartProperties || 'null'));
    } catch {
      return null;
    }
  }

  // The drawer heading shows a focus ring only when the last input was a key. Safari leaves focus where it was after a
  // tap or click on a button, so it drew its own ring on the heading after every open. focus() on a heading that already
  // has focus changes nothing in WebKit, so it is blurred first: the refreshed listener at the end of this script can
  // focus it during the open animation (the buy-box add-on and the quiz open the drawer before their refresh). Every other
  // focus this script moves after a tap does the same (focusVisible: lastInputKey): the refreshed stepper button, the
  // upsell box, a refused line's field, the heading after Remove and the filter drawer on touch all got Safari's ring.
  let lastInputKey = false;
  document.addEventListener('keydown', () => { lastInputKey = true; }, true);
  document.addEventListener('pointerdown', () => { lastInputKey = false; }, true);
  function focusHeading(drawer) {
    const heading = drawer.querySelector('[data-cart-heading]');
    if (heading && heading === document.activeElement && !lastInputKey) heading.blur();
    heading?.focus({ preventScroll: true, focusVisible: lastInputKey });
  }

  // dialog:after-show does not bubble (theme.js), so only a capture listener hears it. Touch screens need it: there
  // the focus trap focuses nothing, and focus stayed on the page behind the open drawer. The same goes for the filter
  // drawer on collections and /search: on touch it takes focus itself (tabindex="-1"), as it does with a mouse.
  document.addEventListener('dialog:after-show', event => {
    if (event.target.id === 'cart-drawer') focusHeading(event.target);
    else if (event.target.localName === 'facets-drawer' && !window.matchMedia(window.themeVariables.mediaQueries['supports-hover']).matches) event.target.focus({ preventScroll: true, focusVisible: lastInputKey });
  }, true);

  // The focus trap does not know the filter drawer's close button (tabbable skips the shadow content of a host with
  // tabindex="-1"), so Shift+Tab from it left the drawer and scrolled the page behind it. It goes to the last footer
  // button ('Toepassen') instead. At the document the event target is the drawer itself.
  document.addEventListener('keydown', event => {
    const drawer = event.target;
    if (event.key !== 'Tab' || !event.shiftKey || drawer.localName !== 'facets-drawer' || !drawer.hasAttribute('open')) return;
    if (!drawer.shadowRoot?.activeElement?.matches('[part~="close-button"]')) return;
    const last = [...drawer.querySelectorAll('[slot="footer"] button')].pop();
    if (!last) return;
    event.preventDefault();
    last.focus();
  }, true);

  // The trap's own wrap skipped 'Sluiten' in both directions: forward Tab from that last footer button went to the first
  // filter, and Shift+Tab from the first filter to the footer button. Both go to the close button, so the backward cycle
  // is the forward one reversed. The first filter is the control the trap wraps from, found as its tabbable finds it: the
  // drawer's own content in order, rendered, enabled, in the tab order and not inside a closed <details> (its summary
  // excepted). The trap's listener (added when the drawer opens, after this one) would wrap anyway, so this one stops it.
  function firstFacetControl(drawer) {
    return [...drawer.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')].find(element => element.tabIndex >= 0
      && !element.disabled && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
      && !(element.localName === 'summary' ? element.parentElement : element).matches('details:not([open]) *'));
  }
  document.addEventListener('keydown', event => {
    const drawer = event.target.closest?.('facets-drawer[open]');
    if (event.key !== 'Tab' || !drawer) return;
    const edge = event.shiftKey ? firstFacetControl(drawer) : [...drawer.querySelectorAll('[slot="footer"] button')].pop();
    const close = drawer.shadowRoot?.querySelector('[part~="close-button"]');
    if (!edge || !close || event.target !== edge) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    close.focus();
  }, true);

  // Up to 500px high (phones in landscape; from 700px wide the lines and the footer of the drawer scroll in two columns,
  // custom-style.css) a shown error comes into view, and so does a control that keyboard focus reaches out of view: the
  // focus trap wraps with preventScroll. Taps keep the scroll (no :focus-visible on a tap).
  const shortScreen = window.matchMedia('(max-height: 500px)');
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    const showError = () => {
      const error = cartDrawer.querySelector('[data-cart-error]:not([hidden])');
      if (error && shortScreen.matches && cartDrawer.hasAttribute('open')) error.scrollIntoView({ block: 'center' });
    };
    new MutationObserver(showError).observe(cartDrawer, { subtree: true, attributeFilter: ['hidden'] });
    // The re-render after a refused change brought back an older scroll position (WebKit): once more after it.
    document.addEventListener('cart-drawer:refreshed', () => setTimeout(showError, 150));
    cartDrawer.addEventListener('focusin', ({ target }) => {
      if (!shortScreen.matches || target === cartDrawer || target.closest('[slot="header"]')) return;
      // While an error shows it stays in view (the refused line gets focus back after the re-render).
      if (cartDrawer.querySelector('[data-cart-error]:not([hidden])')) return;
      try {
        if (target.matches(':focus-visible')) target.scrollIntoView({ block: 'nearest' });
      } catch {}
    });

    // An empty drawer gets its two columns only once the refresh brings the lines (custom-style.css: from 700px wide, up
    // to 500px high, after the cookie choice). The buy-box add-on and the quiz fill the cart outside the product form and
    // opened the drawer at once, so the open drawer then jumped from 481 to 781px. There they open it after the refresh,
    // as the product form does (variant:add); everywhere else at once, as before. Opened another way meanwhile, it does
    // not open again by itself; without a refresh it opens after 5 s (changeQuantity waits as long for the same event).
    // The keep-wide listeners below use the same range and guard.
    const twoColumns = window.matchMedia('screen and (min-width: 700px) and (max-height: 500px)');
    cartDrawer.restyShowAfterAdd = () => {
      if (typeof cartDrawer.show !== 'function') return;
      if (!twoColumns.matches || !cartDrawer.matches('.drawer--center-body[data-cart-refresh-pending]') || document.documentElement.matches('[style*="--resty-cookie-card-height"]')) {
        cartDrawer.show();
        return;
      }
      let shown = false;
      const show = () => {
        if (shown) return;
        shown = true;
        cartDrawer.show();
      };
      cartDrawer.addEventListener('dialog:before-show', () => { shown = true; }, { once: true });
      cartDrawer.addEventListener('cart-drawer:refreshed', show, { once: true });
      setTimeout(show, 5000);
    };

    // The mirror case: Remove of the last line while the drawer is open in two columns. Only a drawer with lines gets
    // the two-column width, so the open drawer narrowed in one frame after the fade (844 x 390: 781 to 481px, a layout
    // shift of 0.24-0.36). It now keeps that width, with the empty state centred, until it closes (data-resty-keep-wide,
    // custom-style.css); the next empty open is 481px as before. Same range and guard as restyShowAfterAdd above and the
    // CSS block: change all three together.
    let keepWide = false;
    cartDrawer.addEventListener('line-item:will-change', () => {
      keepWide = twoColumns.matches && cartDrawer.hasAttribute('open') && !cartDrawer.classList.contains('drawer--center-body') && !document.documentElement.matches('[style*="--resty-cookie-card-height"]');
    }, true);
    // theme.js toggles drawer--center-body and dispatches this in the same task, so no frame shows the narrow drawer.
    cartDrawer.addEventListener('cart-drawer:refreshed', () => {
      if (keepWide && cartDrawer.hasAttribute('open') && cartDrawer.classList.contains('drawer--center-body')) cartDrawer.setAttribute('data-resty-keep-wide', '');
      keepWide = false;
    });
    // dialog:after-hide does not bubble: on the drawer itself.
    cartDrawer.addEventListener('dialog:after-hide', () => cartDrawer.removeAttribute('data-resty-keep-wide'));
  }

  // A re-render replaces the free-shipping track: start it from the previous value so the CSS transition shows the change.
  let shippingProgress = document.querySelector('#cart-drawer .resty-free-shipping-progress')?.style.getPropertyValue('--free-shipping-progress');
  document.addEventListener('cart-drawer:refreshed', event => {
    const track = event.target.querySelector('.resty-free-shipping-progress');
    const next = track?.style.getPropertyValue('--free-shipping-progress');
    if (track && shippingProgress && shippingProgress !== next) {
      track.style.setProperty('--free-shipping-progress', shippingProgress);
      track.getBoundingClientRect();
      track.style.setProperty('--free-shipping-progress', next);
    }
    shippingProgress = next;
  });

  // Trust line under the checkout button: the separator after the last part of each visual line is hidden, so no
  // "·" hangs at a line end. Re-checked whenever the line changes size (drawer opened, resized, re-rendered). The
  // delivery date snippet brings its own script into the line; it is not a part.
  const trustLines = new ResizeObserver(entries => {
    for (const { target } of entries) {
      const parts = [...target.children].filter(part => part.localName !== 'script');
      parts.forEach((part, index) => part.toggleAttribute('data-line-end', parts[index + 1]?.offsetTop !== part.offsetTop));
    }
  });
  const observeTrustLines = () => {
    trustLines.disconnect();
    document.querySelectorAll('#cart-drawer .resty-cart-trust-footer').forEach(line => trustLines.observe(line));
  };
  observeTrustLines();
  document.addEventListener('cart-drawer:refreshed', observeTrustLines);

  // A refresh brings a new, empty status node (theme.js replaceChildren), and text in a live region that is inserted
  // and filled at once is often not announced: cleared, then written 100 ms later, as theme.js announceText does. One
  // timer for the drawer: the other status writes cancel it, and it writes only into an empty node while no change runs.
  let statusTimer;
  function announceUpdated(status) {
    clearTimeout(statusTimer);
    if (!status) return;
    status.textContent = '';
    statusTimer = setTimeout(() => {
      if (status.isConnected && !status.textContent && !pending) status.textContent = status.dataset.updated;
    }, 100);
  }

  async function changeQuantity(drawer, control, key, quantity, focusAfter) {
    if (pending || window.restyCart?.pending) return;
    resync = null;
    const input = control.closest('line-item-quantity').querySelector('input[data-line-key]');
    input.required = true;
    if (!Number.isInteger(quantity) || quantity < 0 || (quantity > 0 && !input.checkValidity())) {
      input.reportValidity();
      input.value = input.defaultValue;
      return;
    }
    pending = true;
    // The field shows the requested number at once (minus, plus, Remove); the catch below puts the old one back.
    if (control !== input) input.value = String(quantity);
    const line = control.closest('line-item');
    const identity = renderedLineIdentity(line);
    const uniqueIdentity = identity && [...drawer.querySelectorAll('[data-cart-line-key]')].filter(item => renderedLineIdentity(item) === identity).length === 1;
    const focusSelector = control === input ? 'input[data-line-key]' : control.matches('.quantity-selector__button')
      ? `quantity-selector > .quantity-selector__button:${quantity > Number(input.defaultValue) ? 'last' : 'first'}-child`
      : 'line-item-quantity > a';
    const error = drawer.querySelector('[data-cart-error]');
    const status = drawer.querySelector('[data-cart-status]');
    error.hidden = true;
    clearTimeout(statusTimer);
    status.textContent = status.dataset.updating;
    drawer.setAttribute('data-quantity-pending', '');
    drawer.querySelector('.cart-drawer__items').setAttribute('aria-busy', 'true');
    const checkout = drawer.querySelector('[name="checkout"]');
    checkout?.setAttribute('aria-disabled', 'true');
    const quantityInputs = [...drawer.querySelectorAll('input[data-line-key]')];
    quantityInputs.forEach(element => { element.readOnly = true; });
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    line.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: quantity } }));
    let refreshed;
    let refreshTimeout;
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const cart = await window.restyCart.change({ id: key, quantity, sections: [...new Set(sections)].join(','), sections_url: window.location.pathname }, identity);
      if (window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }
      const sectionHtml = cart.sections?.[drawer.dataset.sectionId];
      if (!sectionHtml || !new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('cart-drawer')) {
        window.location.assign(`${Shopify.routes.root}cart`);
        return;
      }
      let updatedItem = cart.items.find(item => item.key === key);
      if (!updatedItem && quantity > 0 && uniqueIdentity) {
        const matches = cart.items.filter(item => lineIdentity(item.variant_id, item.selling_plan_allocation?.selling_plan?.id, item.properties) === identity);
        if (matches.length === 1) updatedItem = matches[0];
      }
      const updated = new Promise((resolve, reject) => {
        refreshed = resolve;
        drawer.addEventListener('cart-drawer:refreshed', refreshed, { once: true });
        refreshTimeout = setTimeout(() => reject(new Error()), 5000);
      });
      if (updatedItem || quantity === 0) {
        line.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true, detail: { quantity: updatedItem?.quantity ?? 0, cart } }));
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart } }));
      await updated;
      const currentLine = updatedItem && [...drawer.querySelectorAll('[data-cart-line-key]')].find(item => item.dataset.cartLineKey === updatedItem.key);
      let focusTarget = focusAfter ? drawer.querySelector(focusAfter) : currentLine?.querySelector(focusSelector);
      if (focusTarget?.matches(':disabled')) focusTarget = currentLine.querySelector('input[data-line-key]');
      if (drawer.hasAttribute('open')) {
        if (focusTarget) focusTarget.focus({ preventScroll: true, focusVisible: lastInputKey });
        else focusHeading(drawer);
      }
      announceUpdated(drawer.querySelector('[data-cart-status]'));
    } catch (failure) {
      input.value = input.defaultValue;
      const message = drawer.querySelector('[data-cart-error-message]');
      const text = failure?.cartMessage || message?.dataset.fallback;
      if (message) {
        drawer.querySelector('[data-cart-error]').hidden = false;
        message.textContent = text;
      }
      clearTimeout(statusTimer);
      drawer.querySelector('[data-cart-status]').textContent = '';
      // Shopify can apply part of a change and still refuse it (a stock limit sets the line to what is left), and a
      // failed request leaves restyCart.needsRefresh blocking checkout: re-render from cart.js, as the add flow does
      // after a cart:error. The refreshed drawer shows this message again and gets focus back on this line (set after
      // the dispatch: the cart:refresh listener below drops an older one).
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      resync = { at: Date.now(), text, key, focusAfter };
    } finally {
      clearTimeout(refreshTimeout);
      if (refreshed) drawer.removeEventListener('cart-drawer:refreshed', refreshed);
      pending = false;
      drawer.removeAttribute('data-quantity-pending');
      drawer.querySelector('.cart-drawer__items')?.removeAttribute('aria-busy');
      checkout?.removeAttribute('aria-disabled');
      quantityInputs.forEach(element => { element.readOnly = false; });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  // Upsell checkbox: checking submits the card's product form (the shared add flow, with its events and attribution);
  // unchecking removes only the line this card added, through that line's own Remove control.
  let upsellRequest = null;
  function toggleUpsell(drawer, card, input) {
    const status = drawer.querySelector('[data-cart-status]');
    drawer.querySelector('[data-cart-error]').hidden = true;
    upsellRequest = { at: Date.now(), error: null };
    if (input.checked) {
      card.setAttribute('aria-busy', 'true');
      clearTimeout(statusTimer);
      status.textContent = status.dataset.updating;
      const form = card.querySelector('form');
      if (HTMLFormElement.prototype.requestSubmit) {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      return;
    }
    const line = [...drawer.querySelectorAll('[data-cart-line-key]')].find(item => item.dataset.cartLineKey === card.dataset.lineKey);
    const remove = line?.querySelector('line-item-quantity > a[href*="quantity=0"]');
    if (!remove) {
      input.checked = true;
      upsellRequest = null;
      window.restyShowCartError?.();
      return;
    }
    card.setAttribute('aria-busy', 'true');
    changeQuantity(drawer, remove, card.dataset.lineKey, 0, '.resty-cart-upsell__check').finally(() => {
      // A failed removal keeps this drawer and the line, so the box stays checked.
      if (card.isConnected) {
        input.checked = true;
        card.removeAttribute('aria-busy');
        upsellRequest = null;
      }
    });
  }

  document.addEventListener('cart:error', event => {
    const card = event.target.closest?.('#cart-drawer .resty-cart-upsell');
    if (!card || !upsellRequest) return;
    card.removeAttribute('aria-busy');
    card.querySelector('.resty-cart-upsell__check').checked = false;
    upsellRequest.error = event.detail?.error || '';
    window.restyShowCartError?.(upsellRequest.error);
  });

  // The product form re-renders the drawer after an add (and after a failed one): keep focus on the box and the error
  // in view.
  document.addEventListener('cart-drawer:refreshed', event => {
    const request = upsellRequest;
    upsellRequest = null;
    if (!request || Date.now() - request.at > 15000) return;
    if (request.error !== null) {
      window.restyShowCartError?.(request.error);
    } else {
      announceUpdated(event.target.querySelector('[data-cart-status]'));
    }
    if (event.target.hasAttribute('open')) event.target.querySelector('.resty-cart-upsell__check')?.focus({ preventScroll: true, focusVisible: lastInputKey });
  });

  // After a refused quantity change (changeQuantity's catch): the message again, and focus on the same control. Only
  // the refresh that catch dispatched counts: a later refresh (an add's error path, a discount, the quiz) or a change
  // from anything else (an add, the next quantity change) drops it, also when that refresh failed.
  document.addEventListener('cart:refresh', () => { resync = null; });
  document.addEventListener('cart:change', event => {
    if (event.detail?.baseEvent !== 'cart:refresh') resync = null;
  }, true);
  document.addEventListener('cart-drawer:refreshed', event => {
    const request = resync;
    resync = null;
    if (!request || Date.now() - request.at > 15000) return;
    window.restyShowCartError?.(request.text);
    const drawer = event.target;
    const line = [...drawer.querySelectorAll('[data-cart-line-key]')].find(item => item.dataset.cartLineKey === request.key);
    const target = request.focusAfter ? drawer.querySelector(request.focusAfter) : line?.querySelector('input[data-line-key]');
    if (drawer.hasAttribute('open')) {
      if (target) target.focus({ preventScroll: true, focusVisible: lastInputKey });
      else focusHeading(drawer);
    }
  });

  // A discount code that applies (or is removed) re-renders the drawer and takes the focused control with it: focus
  // goes to the new "Discount code?" summary, not out of the dialog. Never moves focus that is still somewhere.
  // Without a ring, as before the Enter: its ring ran under the code field's label and, on phones, into the card and totals.
  let discountRequest = 0;
  document.addEventListener('cart:refresh', event => {
    if (event.target.closest?.('#cart-drawer :is(cart-discount-field, cart-discount-remove-button)')) discountRequest = Date.now();
  });
  document.addEventListener('cart-drawer:refreshed', event => {
    const at = discountRequest;
    discountRequest = 0;
    if (!at || Date.now() - at > 15000 || !event.target.hasAttribute('open') || document.activeElement !== document.body) return;
    (event.target.querySelector('.resty-cart-discount-disclosure summary') || event.target.querySelector('[data-cart-heading]'))?.focus({ preventScroll: true, focusVisible: false });
  });

  for (const type of ['click', 'change', 'submit']) {
    document.addEventListener(type, event => {
      const drawer = event.target.closest?.('#cart-drawer');
      if (!drawer) return;
      const inPurchaseArea = event.target.closest('.cart-drawer__items, .cart-drawer__footer, product-form');
      if (pending && inPurchaseArea) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const upsell = event.target.closest('.resty-cart-upsell');
      if (upsell) {
        // One cart request at a time: a click while one runs would flip the box without an outcome.
        if (type === 'click' && (upsell.hasAttribute('aria-busy') || window.restyCart?.pending)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        } else if (type === 'change' && event.target.matches('.resty-cart-upsell__check')) {
          toggleUpsell(drawer, upsell, event.target);
        }
        return;
      }
      const control = type === 'change' ? event.target.closest('line-item-quantity input[data-line-key]') : type === 'click' ? event.target.closest('line-item-quantity a[href*="/cart/change"]') : null;
      if (!control) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = control.href ? new URL(control.href) : null;
      const key = url ? url.searchParams.get('id') : control.dataset.lineKey;
      const quantity = Number(url ? url.searchParams.get('quantity') : control.value.trim() || NaN);
      changeQuantity(drawer, control, key, quantity);
    }, true);
  }

  // A refresh replaces the drawer's children (theme.js replaceChildren), and with them the heading the after-show
  // listener above focused: the buy-box add-on and the quiz open the drawer before their refresh, so focus fell to the
  // page behind it. Back to the heading when nothing else took focus; registered last, after the upsell, refused-change
  // and discount listeners. A quantity change focuses its own control after the refresh.
  document.addEventListener('cart-drawer:refreshed', ({ target }) => {
    if (target.id !== 'cart-drawer' || !target.hasAttribute('open') || target.hasAttribute('data-quantity-pending')) return;
    if (document.activeElement && document.activeElement !== document.body) return;
    focusHeading(target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  // Trust line under the checkout button: the separator after the last part of each visual line is hidden (same as the
  // drawer). A cart change on this page reloads it, so observing the line once covers resizes and re-wraps.
  const trustLines = new ResizeObserver(entries => {
    for (const { target } of entries) {
      const parts = [...target.children];
      parts.forEach((part, index) => part.toggleAttribute('data-line-end', parts[index + 1]?.offsetTop !== part.offsetTop));
    }
  });
  document.querySelectorAll('.resty-main-cart-trust__line').forEach(line => trustLines.observe(line));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonials-38"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('resty-testimonials')) {
    customElements.define('resty-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-review-viewport]');
        if (!this.viewport) return;
        this.reviews = [...this.querySelectorAll('[data-review]')];
        this.controls = this.querySelector('[data-review-controls]');
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(), 100);
        }, { ...options, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          const rtl = getComputedStyle(this.viewport).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.reviews.length - 1);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.reviews.findIndex((review) => review.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, 'auto');
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.scrollTimer);
      }

      range() {
        const bounds = this.viewport.getBoundingClientRect();
        const visible = this.reviews.map((review, index) => ({ index, rect: review.getBoundingClientRect() }))
          .filter(({ rect }) => Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > 8);
        return [visible[0]?.index || 0, visible.at(-1)?.index || 0];
      }

      update() {
        const overflow = this.viewport.scrollWidth - this.viewport.clientWidth > 2;
        this.controls.hidden = !overflow;
        const [first, last] = this.range();
        const bounds = this.viewport.getBoundingClientRect();
        const firstRect = this.reviews[0].getBoundingClientRect();
        const lastRect = this.reviews.at(-1).getBoundingClientRect();
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.previous.setAttribute('aria-disabled', String(!overflow || (rtl ? firstRect.right <= bounds.right + 5 : firstRect.left >= bounds.left - 5)));
        this.next.setAttribute('aria-disabled', String(!overflow || (rtl ? lastRect.left >= bounds.left - 5 : lastRect.right <= bounds.right + 5)));
        const format = (first === last && this.status.dataset.formatSingle) || this.status.dataset.format;
        const message = format.replace('[first]', first + 1).replace('[last]', last + 1).replace('[total]', this.reviews.length);
        if (this.status.textContent !== message) this.status.textContent = message;
      }

      move(direction) {
        this.update();
        const button = direction < 0 ? this.previous : this.next;
        if (button.getAttribute('aria-disabled') === 'true') return;
        this.goTo(this.range()[0] + direction);
      }

      goTo(index, behavior) {
        const review = this.reviews[Math.max(0, Math.min(index, this.reviews.length - 1))];
        const bounds = this.viewport.getBoundingClientRect();
        const rect = review.getBoundingClientRect();
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.viewport.scrollBy({
          left: rtl ? rect.right - bounds.right + 4 : rect.left - bounds.left - 4,
          behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'),
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
